import type { SliceComponentProps } from "@prismicio/react";
import { asText } from "@prismicio/helpers";
import { useMemo } from "react";
import { wrapIframe } from "@commercekit/shared";
import WvCampaignPhotoUploadForm from "~/components/organisms/WvCampaignPhotoUploadForm";
import type { CampaignPhotoUploadSlice } from "prismicio-types";

const CampaignPhotoUpload = ({
  slice,
}: SliceComponentProps<CampaignPhotoUploadSlice>) => {
  const title = asText(slice.primary.title);
  const content = useMemo(
    () => wrapIframe(slice.primary.content || "") || "",
    [slice.primary.content]
  );

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="fotocampagne-page"
    >
      <div className="fotocampagne-page__inner">
        <div className="fotocampagne-page__text">
          {title && (
            <h1 className="fotocampagne-page__title heading strong lg left">
              {title}
            </h1>
          )}
          {content && (
            <div
              className="fotocampagne-page__description content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
        <div className="fotocampagne-page__form">
          <WvCampaignPhotoUploadForm />
        </div>
      </div>
    </section>
  );
};

export default CampaignPhotoUpload;
